import _ from 'lodash';
import browser from '@openclassrooms/utils/browser';
import User from './User';
import CantRetrieveCurrentUserException from './CantRetrieveCurrentUserException';

function getUserPropertiesFromGlobal() {
  return browser.window.App.user;
}

function hasAppUserSet() {
  const varIsSet = browser.window.App && browser.window.App.user;
  const userProperties = varIsSet ? getUserPropertiesFromGlobal() : null;
  const id = userProperties ? userProperties.id : null;

  return varIsSet && id;
}

class CurrentUser {
  /**
   * @return {User}
   */
  static get() {
    if (!hasAppUserSet()) {
      throw new CantRetrieveCurrentUserException();
    }

    const currentUser = new User();
    const properties = getUserPropertiesFromGlobal();

    _.assign(currentUser, properties);

    return currentUser;
  }

  /**
   * @return {Boolean}
   */
  static hasCurrentUser() {
    return hasAppUserSet();
  }
}

export default CurrentUser;
